import Skeleton from "common/components/ui/Skeleton";
import useEstimateRenewal from "common/datahooks/useEstimateRenewal";
import { formatPeriodUnitLabel, formatPrice } from "common/helpers/utils";
import type { Subscription } from "common/types";

interface CurrentCountProps {
  subscription: Subscription;
  currentCount: number;
}

export default function CurrentCount({
  subscription,
  currentCount,
}: CurrentCountProps) {
  const { estimateRenewal, isLoadingEstimateRenewal } =
    useEstimateRenewal(subscription);

  return (
    <>
      <div className="flex items-center justify-between px-2 py-1">
        <span className="text-button-sm text-black-600">
          Current no. of seats
        </span>
        <span className="text-md-medium text-black-500">{currentCount}</span>
      </div>

      <div className="flex items-center justify-between px-2 py-1">
        <span className="text-button-sm text-black-600">Current price</span>
        {isLoadingEstimateRenewal || !estimateRenewal ? (
          <Skeleton className="h-5 w-14" />
        ) : (
          <span className="text-md-medium text-black-500">
            {formatPrice(estimateRenewal.amountDue / 100)}/
            {formatPeriodUnitLabel(subscription.item_price.period_unit)}
          </span>
        )}
      </div>

      <span className="h-px w-full bg-black-200" />
    </>
  );
}
